<!-- =========================================================================================
    File Name: MailItem.vue
    Description: Mail Item - Displays mail item
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="mail__mail-item sm:px-4 px-2 py-6">

        <!-- MAIL ROW 1 : META -->
        <div class="flex w-full">
            <!-- <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white" :src="mail.img" size="40px"></vs-avatar> -->
            <!-- <vs-avatar class="sender__avatar flex-shrink-0 mr-3 border-2 border-white" src="@/assets/images/portrait/small/avatar-s-11.jpg"  size="40px"></vs-avatar> -->
            <!-- <img key="onlineImg" :src="photoURL" alt="user-img" width="40" height="40" class="sender__avatar flex-shrink-0 mr-3 border-2 border-white rounded-full shadow-md cursor-pointer block" /> -->
            <div class="vx-row" style="margin:10px; padding:2px;">
              <!-- <vs-chip v-if="studentNotice.service" color="#28c76f" style="width:100%; height:20px; margin-right:10px;">on</vs-chip>
              <vs-chip v-if="!studentNotice.service" color="#d5d5d5" style="margin-right:10px;">off</vs-chip> -->
            </div>
            <div class="flex w-full justify-between items-start ">

                <div class="mail__details">
                    <!-- <h5 class="mb-1" :class="{'font-semibold': mail.unread}">{{ notice.name }}</h5> -->
                    <!-- <h5 class="mb-1" :class="{'font-semibold': true}">{{ studentNotice.name }}</h5> -->
                    <span>{{ studentNotice.title }}</span>
                </div>

                <div class="mail-item__meta flex items-center">
                    <!-- <div class="email__labels hidden sm:flex items-center">
                        <div class="h-2 w-2 rounded-full mr-2" :class="'bg-' + labelColor(label)" v-for="(label, index) in mail.labels" :key="index"></div>
                    </div> -->
                    <vs-chip color="warning" style="margin-right:10px;">{{studentNotice.comment_count}}</vs-chip>
                    <span>{{ studentNotice.update_time | date }}</span>
                </div>
            </div>
        </div>
        <!-- /MAIL ROW 1 -->

        <!-- MAIL ROW 2 : MSG & ACTIONS -->
        <div class="flex w-full">
            <div class="flex items-center ml-1">
                <!-- <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox> -->
                <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning fill-current stroke-current': mail.isStarred}, 'w-5', 'h-5']" @click.stop="toggleIsStarred"></feather-icon> -->
            </div>
            <!-- <div class="mail__message truncate ml-3">
                <span>{{ notice.detail | filter_tags }}</span>
            </div> -->
        </div>
        <!-- /MAIL ROW 2 -->
    </div>
</template>

<script>
export default {
  props: ['studentNotice'],
  selected: [],
  data() {
    return {
      // photoURL:require("@/assets/images/portrait/small/" + this.notice['photo_url'])
    }
  },
  created(){
  }
  // data() {
  //   return {
  //     isSelectedMail: this.isSelected,
  //   }
  // },
  // watch: {
  //   isSelected(value) {
  //     this.isSelectedMail = value
  //   },
  //   isSelectedMail(val) {
  //     val ? this.$emit('addToSelected', this.mail.id) : this.$emit('removeSelected', this.mail.id)
  //   }
  // },
  // computed: {
  //   labelColor() {
  //     return (label) => {
  //       const tags = this.$store.state.email.mailTags
  //       return tags.find((tag) => {
  //         return tag.value == label
  //       }).color
  //     }
  //   },
  // },
  // methods: {
  //   toggleIsStarred() {
  //     const payload = { mailId: this.mail.id, value: !this.mail.isStarred }
  //     this.$store.dispatch('email/toggleIsMailStarred', payload)
  //   }
  // }

}

</script>
